module.exports = __webpack_public_path__ + "static/media/cornerOk.d38f8d57.svg";